import Select from "./SelectBase";

const InputForm = ({
  campo,
  value,
  onChange,
  opciones,
  modoEdicion,
  campoNoEditable,
}) => {
  const campoBloqueado = campoNoEditable === campo.key;
  const disabled = modoEdicion && campo.isId && campo.notChange;
  const isDisabled = disabled || campoBloqueado;
  return (
    <div className="form-info">
      {campo.inputType !== "boolean" && (
        <strong>
          {campo.label}
          {campo.important && <span className="complete"> * obligatorio</span>}
        </strong>
      )}

      {/* INPUT */}
      {campo.inputType === "input" && (
        <input
          className="form-input"
          style={
            campo.dato === "text" ? { textTransform: "uppercase" } : undefined
          }
          type={campo.dato || "text"}
          value={value ?? ""}
          onChange={(e) => onChange(campo.key, e.target.value)}
          disabled={isDisabled}
        />
      )}

      {/* TEXTAREA */}
      {campo.inputType === "textarea" && (
        <textarea
          className="form-textarea"
          value={value ?? ""}
          onChange={(e) => onChange(campo.key, e.target.value)}
          disabled={isDisabled}
        />
      )}

      {/* SELECT (inputOptions)*/}
      {/* `campo.options` es un vocabulario CERRADO escrito con el campo, y
          `campo.optionsList` es una lista que sale de la base. El primero gana:
          los estados de una unidad no son un padrón que alguien mantiene, son
          cinco palabras que decide el código — meterlas en `cargarSelects`
          sería salir a la red a buscar algo que ya está acá, y dejar la lista
          vacía el día que esa consulta falle. */}
      {campo.inputType === "inputOptions" && (
        <Select
          className="form-input"
          options={
            campo.options || [
              { value: "", label: "SIN ASIGNAR" },
              ...(opciones[campo.optionsList] || []),
            ]
          }
          value={
            (campo.options || opciones[campo.optionsList] || []).find(
              (opt) => opt.value === value,
            ) || null
          }
          onChange={(opt) => onChange(campo.key, opt ? opt.value : "")}
          isClearable
          placeholder="Seleccionar..."
          noOptionsMessage={() => "Sin opciones"}
          isDisabled={isDisabled}
        />
      )}

      {/* MULTI SELECT (multiOptions) */}

      {campo.inputType === "multiOptions" && (
        <Select
          isMulti
          className="form-input"
          options={opciones[campo.optionsList] || []}
          value={(opciones[campo.optionsList] || []).filter(
            (opt) => Array.isArray(value) && value.includes(opt.value),
          )}
          onChange={(opts) => {
            const values = opts ? opts.map((o) => o.value) : [];

            // si tiene limite
            if (campo.inputLimit && values.length > campo.inputLimit) {
              return;
            }

            onChange(campo.key, values);
          }}
          placeholder="Seleccionar..."
          noOptionsMessage={() => "Sin opciones"}
          isDisabled={isDisabled}
        />
      )}

      {/* BOOLEAN — DOS OPCIONES A LA VISTA, NO UN INTERRUPTOR.
          Antes era un botón solo que mostraba el estado actual: decía "FURGÓN
          VACÍO", se apretaba, y quedaba verde diciendo "FURGÓN CARGADO". No se
          podía saber si el texto era lo que ES o lo que va a PASAR si lo tocás
          — y en portería eso se carga apurado, con la barrera abajo.

          Y el verde empeoraba la lectura: los dos valores son estados legítimos
          —un furgón vacío no tiene nada de malo— pero el verde se lee como
          "correcto" y el gris como "falta hacer algo", así que la gente lo
          apretaba para "completarlo".

          Con las dos opciones dibujadas no hay nada que adivinar: se elige, no
          se alterna. Y la elegida se marca por contraste y no por color, para
          que ninguna de las dos parezca la respuesta buena. */}
      {campo.inputType === "boolean" && (
        <div className="boolean-container" role="group"
             aria-label={campo.label}>
          <button
            type="button"
            className={`boolean-opcion ${value === false ? "elegida" : ""}`}
            onClick={() => onChange(campo.key, false)}
            disabled={isDisabled}
            aria-pressed={value === false}
          >
            {campo.negative}
          </button>
          <button
            type="button"
            className={`boolean-opcion ${value === true ? "elegida" : ""}`}
            onClick={() => onChange(campo.key, true)}
            disabled={isDisabled}
            aria-pressed={value === true}
          >
            {campo.positive}
          </button>
        </div>
      )}

      {/* BOOLEAN DOUBLE */}
      {campo.inputType === "booleanDouble" && (
        <div className="type-container">
          <button
            type="button"
            className={
              value === campo.optionOne ? "type-btn active" : "type-btn"
            }
            onClick={() => onChange(campo.key, campo.optionOne)}
            disabled={isDisabled}
          >
            {campo.optionOne}
          </button>

          <button
            type="button"
            className={
              value === campo.optionTwo ? "type-btn active-green" : "type-btn"
            }
            onClick={() => onChange(campo.key, campo.optionTwo)}
            disabled={isDisabled}
          >
            {campo.optionTwo}
          </button>
        </div>
      )}

      {/* GROUP */}
      {campo.type === "group" && <div className="container">aaaaaaa</div>}
    </div>
  );
};

export default InputForm;
